import * as React from 'react';

import { useOutsideClose } from '@longline/aqua-ui/hooks/useOutsideClose';
import { Input } from '@longline/aqua-ui/inputs/Input';

interface IProps {
  value: string;
  onEdit: (value: string) => void;
  onClose: () => void;
}

const LayerManagerInput = (props: IProps) => {
  const wrapperRef = React.useRef(null);

  useOutsideClose({
    open: true,
    refs: [wrapperRef],
    onClose: props.onClose,
    escapeToClose: true,
    blurToClose: false,
  });

  return (
    <div style={{padding: "2px"}} ref={wrapperRef}>
      <Input error={props.value.length == 0 || props.value.length > 255} fluid value={props.value} onChange={props.onEdit}/>
    </div>
  )
}

export { LayerManagerInput }
